export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/plans?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setPlans", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getPlan(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/sales/plans/${id}`)
        .then(({ data }) => {
          context.commit("setPlan", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/plans", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/plans/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/sales/plans/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  duplicate(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/sales/plans/${params.id}/duplicate`, params)
        .then(resolve)
        .catch(reject);
    });
  }
};
